import { render, staticRenderFns } from "./Mandate.vue?vue&type=template&id=5e75e0e6&"
import script from "./Mandate.vue?vue&type=script&lang=js&"
export * from "./Mandate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports